import { setReturnPath } from "@/auth/session";

/* Sending a guest to sign in, from a public page, without losing their place.
 *
 * The contract Login already honours: setReturnPath() then navigate to
 * /login, and takeReturnPath() puts them back afterwards. This wraps the pair
 * so every guest affordance does it the same way -- a guest who clicks
 * "sign in to contact" on a listing must land back on THAT listing, not on
 * the homepage (defect D-W1).
 *
 * Call it with the location you want to come back to, which is almost always
 * the page the control is on.
 */
export function goToLoginAndReturn(
  navigate: (to: string, opts?: { replace?: boolean }) => void,
  returnTo: string,
): void {
  setReturnPath(returnTo);
  navigate("/login");
}
